export default {
  Delete : 'Delete',
  ReportWantToDelete : 'ReportWantToDelete',
};
